import { useT } from '@transifex/react';
import { getAutomationRulesKeyMessageMap } from './automation-rules';

export const AutomationRuleName = ({
  automationRule,
}: {
  automationRule: Oneflow.AutomationRule;
}) => {
  const t = useT();

  const ruleName = getAutomationRulesKeyMessageMap(t)[automationRule.key];

  return <>{ruleName || automationRule.key}</>;
};
